import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./postal-code.scss";
import {cx} from "emotion";
import {UseState} from "../../../../../../../../../react/use-state";
import {bindInput} from "../../../../../../../../../react/bind-input";
import {Form2} from "../../../../../../../../../react/cs-form-2/form2";
import {required} from "../../../../../../../../../react/cs-form-2/validators/required";
import {chain} from "../../../../../../../../../utils/fs";
import {cc} from "../../../../../../../../../react/callback-chain";

export const PostalCode = ({showErrors: showErrors1, onSearch, query}) => cs(    
    ["showErrors", (_, next) => UseState({next})],
    ["apiError", (_, next) => UseState({next})],
    ["data", ({apiError}, next) => cc([
        (_, next) => UseState({
            initValue: {postalCodes: query.value?.postalCodes},
            next
        }),
        ({value, onChange}) => next({
            value,
            onChange: (v) => {
                onChange(v);
                apiError.onChange(null);
            },
        })
    ])],
    ["form", ({data}, next) => Form2({
        data,
        showErrors: true,
        fields: [{
            path: ["postalCodes"],
            validators: [required],
        }],
        next,
    })],
    ({data, showErrors, form, apiError}) => (
        <div className="postal-code-4ny">
            <div className="label" xd-qa-type="label" xd-qa-name="Demographics Search Enter Zip Codes">
                Enter zip codes you want to target and press Search
            </div>

            {chain(
                form.field("postalCodes"),
                (field) => ({
                    ...field,
                    error: (showErrors.value || showErrors1) && field.error,
                }),
                (field) => (
                    <textarea {...{
                        className: cx({hasError: field.error}),
                        ...bindInput(field.state),
                        onBlur: () => field.state.change((_) => _?.split(/[,\s]+/).join(",")),
                        placeholder: "Separate zip code by commas. (i.e. 92618, 92614, 92635)",
                        "xd-qa-type": "text_field",
                        "xd-qa-name": "Demographics Search Zip Codes",
                    }}/>
                )
            )}

            {apiError.value && (
                <div className="error" xd-qa-type="label" xd-qa-name="Demographics Search Error">
                    {apiError.value.msg ?? "Unknown search error"}
                </div>
            )}

            <div className="clear">
                <a {...{
                    onClick: () => data.onChange(null),
                    "xd-qa-type": "link",
                    "xd-qa-name": "Demographics Search Clear Zip Codes",
                }}>
                    Clear Zip Codes
                </a>
            </div>

            <div className="footer">
                {cs(
                    ["submitting", (_, next) => UseState({next})],
                    ({submitting}) => (
                        <button {...{
                            className: cx("search", {
                                disabled: form.invalid,
                            }),
                            disabled: submitting.value,

                            onClick: () => form.submit({
                                onRejected: () => showErrors.onChange(true),
                                onSubmit: async () => {
                                    submitting.onChange(true);
                                    try {
                                        await onSearch(data.value);
                                    } catch (e) {
                                        apiError.onChange({msg: e});
                                    } finally {
                                        submitting.onChange(false);
                                    }
                                },
                            }),
                            "xd-qa-type": "button",
                            "xd-qa-name": "Demographics Search Search",
                        }}>
                            Search
                        </button>
                    )
                )}
            </div>
        </div>
    ),
);
